import React, { useState, useEffect } from 'react';
import styles from '../styles';

const SectionTitle = ({ children }) => (
  <h2
    style={{
      fontFamily: "'Antonio', sans-serif",
      fontSize: '28px',
      color: '#1B2B3E',
      textTransform: 'uppercase',
      letterSpacing: '-0.5px',
      marginTop: '64px',
      marginBottom: '16px',
    }}
  >
    {children}
  </h2>
);

const P = ({ children }) => (
  <p style={{ fontSize: '16px', color: '#475569', lineHeight: '1.8', marginBottom: '16px' }}>
    {children}
  </p>
);

const TermsPage = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <header
        style={{
          paddingTop: '120px',
          paddingBottom: '64px',
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(20px)',
          transition:
            'opacity 1s cubic-bezier(0.2, 0.8, 0.2, 1), transform 1s cubic-bezier(0.2, 0.8, 0.2, 1)',
        }}
      >
        <div style={styles.container}>
          <h1 style={styles.heroTitleUpper}>Terms of<br />Service.</h1>
          <p style={styles.heroSub}>
            Please read these terms carefully before using FCR Solutions' credit repair services.
          </p>
        </div>
      </header>

      <section style={{ ...styles.container, paddingBottom: '120px', maxWidth: '800px' }}>
        <P>
          <strong>Effective Date:</strong> January 1, 2026
        </P>
        <P>
          These Terms of Service ("Terms") govern your access to and use of the services provided by
          FCR Solutions ("Company," "we," "our," or "us"). By engaging our services, you agree to be
          bound by these Terms. If you do not agree, do not use our services.
        </P>

        <SectionTitle>1. Services Description</SectionTitle>
        <P>
          FCR Solutions provides credit repair and credit restoration services, including but not
          limited to: credit report analysis, dispute preparation and submission to credit bureaus
          (Equifax, Experian, and TransUnion), creditor negotiations, and credit rebuilding
          guidance. Our services are performed in compliance with the Credit Repair Organizations Act
          (CROA), 15 U.S.C. {'\u00A7'} 1679, and all applicable federal and state laws.
        </P>

        <SectionTitle>2. Your Rights Under Federal Law</SectionTitle>
        <P>
          Under the Credit Repair Organizations Act (CROA), you have the right to:
        </P>
        <ul style={{ fontSize: '16px', color: '#475569', lineHeight: '2', marginBottom: '16px', paddingLeft: '24px' }}>
          <li>Dispute inaccurate information in your credit report directly with credit bureaus at no charge</li>
          <li>Cancel your contract with FCR Solutions within three (3) business days of signing without any charge</li>
          <li>Sue a credit repair organization that violates the CROA</li>
          <li>Seek damages from a credit repair organization for violations of federal or state law</li>
        </ul>
        <P>
          No one can legally remove accurate, timely, and verifiable information from your credit
          report. We do not guarantee specific results, credit score increases, or removal of
          accurate information.
        </P>

        <SectionTitle>3. Client Obligations</SectionTitle>
        <P>By using our services, you agree to:</P>
        <ul style={{ fontSize: '16px', color: '#475569', lineHeight: '2', marginBottom: '16px', paddingLeft: '24px' }}>
          <li>Provide accurate and complete personal information necessary for us to perform our services</li>
          <li>Provide copies of your credit reports or authorize us to obtain them on your behalf</li>
          <li>Promptly notify us of any changes to your personal information</li>
          <li>Not misrepresent your identity or credit history</li>
          <li>Cooperate with reasonable requests for documentation or verification</li>
          <li>Make timely payments for services rendered</li>
        </ul>

        <SectionTitle>4. Fees and Payment</SectionTitle>
        <P>
          Our service fees are outlined in your individual service agreement. Key terms include:
        </P>
        <ul style={{ fontSize: '16px', color: '#475569', lineHeight: '2', marginBottom: '16px', paddingLeft: '24px' }}>
          <li>No fees are charged until services have been fully performed, in compliance with CROA</li>
          <li>All plans are billed on a month-to-month basis</li>
          <li>Payment is due on the agreed-upon billing date each month</li>
          <li>We accept major credit cards and ACH bank transfers</li>
          <li>There are no setup fees or hidden charges</li>
        </ul>
        <P>
          Failure to make timely payments may result in suspension or termination of services.
        </P>

        <SectionTitle>5. Cancellation and Refund Policy</SectionTitle>
        <P>
          You may cancel your service at any time with no cancellation fees or penalties. To cancel,
          contact us by email at fcrcreditsolutions@gmail.com or by phone at 888.271.2293. Cancellation
          will take effect at the end of the current billing cycle. Per CROA requirements, you have
          the right to cancel within three (3) business days of signing your service agreement for a
          full refund.
        </P>

        <SectionTitle>6. No Guarantees</SectionTitle>
        <P>
          While we employ proven strategies and have a strong track record, we cannot and do not
          guarantee specific outcomes. Credit repair results vary based on individual circumstances,
          including the nature and accuracy of items on your credit report, creditor and bureau
          response times, and other factors outside our control. Any testimonials or statistics
          referenced on our website represent past client experiences and are not guarantees of
          future results.
        </P>

        <SectionTitle>7. Limitation of Liability</SectionTitle>
        <P>
          To the maximum extent permitted by law, FCR Solutions shall not be liable for any
          indirect, incidental, special, consequential, or punitive damages arising out of or
          relating to your use of our services. Our total liability shall not exceed the total fees
          paid by you during the twelve (12) months preceding the claim. This limitation applies
          regardless of the theory of liability, whether based in contract, tort, negligence, strict
          liability, or any other basis.
        </P>

        <SectionTitle>8. Intellectual Property</SectionTitle>
        <P>
          All content on our website, including text, graphics, logos, images, and software, is the
          property of FCR Solutions and is protected by copyright, trademark, and other intellectual
          property laws. You may not reproduce, distribute, modify, or create derivative works of
          our content without prior written consent.
        </P>

        <SectionTitle>9. Confidentiality</SectionTitle>
        <P>
          We treat all client information as confidential and will not disclose your personal or
          financial information to any third party except as necessary to perform our services (e.g.,
          submitting disputes to credit bureaus), as required by law, or with your express written
          consent. Our full data practices are described in our Privacy Policy.
        </P>

        <SectionTitle>10. Dispute Resolution</SectionTitle>
        <P>
          Any disputes arising out of or relating to these Terms or our services shall first be
          addressed through good-faith negotiation. If a resolution cannot be reached within thirty
          (30) days, either party may submit the dispute to binding arbitration administered by the
          American Arbitration Association (AAA) under its Consumer Arbitration Rules. Arbitration
          shall take place in New York, NY. Nothing in this section limits your rights under CROA to
          bring an action in court.
        </P>

        <SectionTitle>11. Governing Law</SectionTitle>
        <P>
          These Terms shall be governed by and construed in accordance with the laws of the State of
          New York, without regard to its conflict of law provisions, and applicable federal law
          including the CROA and the Fair Credit Reporting Act (FCRA).
        </P>

        <SectionTitle>12. Modifications to Terms</SectionTitle>
        <P>
          We reserve the right to modify these Terms at any time. Material changes will be
          communicated via email or a prominent notice on our website at least thirty (30) days
          before they take effect. Your continued use of our services after the effective date of any
          changes constitutes acceptance of the updated Terms.
        </P>

        <SectionTitle>13. Severability</SectionTitle>
        <P>
          If any provision of these Terms is found to be invalid or unenforceable by a court of
          competent jurisdiction, the remaining provisions shall continue in full force and effect.
        </P>

        <SectionTitle>14. Contact Information</SectionTitle>
        <P>
          For questions about these Terms of Service, please contact us:
        </P>
        <P>
          FCR Solutions<br />
          4193 Flat Rock Dr, Bldg 200<br />
          Riverside, CA 92505<br />
          Email: fcrcreditsolutions@gmail.com<br />
          Phone: 888.271.2293
        </P>
      </section>
    </div>
  );
};

export default TermsPage;
